<sdps-divider variation="secondary"></sdps-divider>
<div class="title-row">
  <div id="section-title" class="title-column">{{sectionTitle}}</div>
  <div class="edit-link-column no-print" *ngIf="showEditLink">
    <a (click)="onEditClick()" id="edit-transaction-link" [class.disabled]="disableEditLink">Edit</a>
  </div>
</div>
<div *ngIf="hasIntermediaryBank=='No'" class="row">
  <div id="wireCondensed_recipientBankInformation" class="bank-title">Recipient Bank</div>
</div>
<div class="row" *ngIf="hasIntermediaryBank=='No'">
  <div class="column">
    <mm-condensed-label-group [title]="labels.bankInformation" [multilineData]="recipientBankInformation.address"></mm-condensed-label-group>
  </div>
  @for (bankDetail of recipientBankInformation.bankSubDetailsArray; track bankDetail.id; let idx = $index) {
  <div class="column">
    <mm-condensed-label-group [id]="bankDetail.id" [title]="bankDetail.title" [data]="bankDetail.data"></mm-condensed-label-group>
  </div>
  }
</div>
<div class="intermediaryInfo" *ngIf="hasIntermediaryBank=='Yes'">
  @for (bankDetail of bankDetails; track bankDetail.id; let idx = $index) {
  <div [ngStyle]="{'grid-column': idx + 1, 'grid-row': 1}">
    <div class="bank-title with-intermediary">{{bankDetails[$index].type}}</div>
    <mm-condensed-label-group [title]="bankDetail.title" [multilineData]="bankDetail.address" [addBottomPadding]="bankDetail.addBottomPadding"></mm-condensed-label-group>
  </div>
  }
  @for (bankSubDetails of bankDetails; track bankSubDetails.id; let idx = $index) {
  <div class="column">
    @for (bankSubDetail of bankSubDetails.bankSubDetailsArray; track bankSubDetail.id; let idx = $index) {
    <div class="row">
      <mm-condensed-label-group [id]="bankSubDetail.id" [title]="bankSubDetail.title" [data]="bankSubDetail.data" [addBottomPadding]="bankSubDetail.addBottomPadding"></mm-condensed-label-group>
    </div>
    }
  </div>
  }
</div>
<hr class="dashed">
<div class="row">
  <div class="column">
    <mm-condensed-label-group id="wireCondensed_transactionType" class="loa loaSubmitDetails" data-loafieldname="{{pdfLabelsSubmitDetails.transactionType}}" [title]="labels.transactionType" [data]="transactionType"></mm-condensed-label-group>
  </div>
  <div class="column">
    <mm-condensed-label-group id="wireCondensed_useStandingAuth" [title]="labels.useStandingAuth" [data]="usingStandingAuth"></mm-condensed-label-group>
  </div>
  <div *ngIf="usingStandingAuth === 'Yes'" class="column">
    <mm-condensed-label-group id="wireCondensed_standingAuthDetails" [title]="isBundledStandingAuthTransaction ? labels.bundledStandingAuthDetails : labels.standingAuthDetails" [multilineData]="standingAuthDetails"></mm-condensed-label-group>
  </div>
  <div class="column">
    <mm-condensed-label-group id="wireCondensed_isIntermediaryBank" [title]="labels.isThereAnIntermediaryInstitutionHorizontalLabel" [data]="hasIntermediaryBank"></mm-condensed-label-group>
  </div>
  <div class="column">
    <mm-condensed-label-group id="wireCondensed_processDate" class="loa loaSubmitDetails" data-loafieldname="{{pdfLabelsSubmitDetails.processDate}}" [title]="labels.processDate" [data]="processDate"></mm-condensed-label-group>
  </div>
  <div class="column">
    <mm-condensed-label-group id="wireCondensed_wireAmount" class="loa loaSubmitDetails" data-loafieldname="{{pdfLabelsSubmitDetails.wireAmount}}" [title]="labels.wireAmount" [data]="wireAmount"></mm-condensed-label-group>
  </div>
  <div *ngIf="isIra" class="column">
    <mm-condensed-label-group id="wireCondensed_grossNet" [title]="labels.grossNet" [data]="grossNet | titlecase"></mm-condensed-label-group>
  </div>
  <div *ngIf="isIra" class="column">
    <ng-container [ngSwitch]="grossNet">
      <mm-condensed-label-group *ngSwitchCase="'net'" id="wireCondensed_netWireAmount" [title]="labels.netWireAmount" [data]="amountIncludingTaxes"></mm-condensed-label-group>
      <mm-condensed-label-group *ngSwitchCase="'gross'" id="wireCondensed_grossWireAmount" [title]="labels.grossWireAmount" [data]="amountIncludingTaxes"></mm-condensed-label-group>
    </ng-container>
  </div>
  <div class="column">
    <mm-condensed-label-group id="wireCondensed_totalWithdrawalAmount" class="loa loaSubmitDetails" data-loafieldname="{{pdfLabelsSubmitDetails.withdrawalAmount}}" [title]="labels.totalWithdrawalAmount" [data]="(totalWithdrawalAmount | currency)!"></mm-condensed-label-group>
  </div>
  <div class="column">
    <mm-condensed-label-group id="wireCondensed_wireFee" class="loa loaSubmitDetails" data-loafieldname="{{pdfLabelsSubmitDetails.wireFee}}" [title]="labels.wireFee" [data]="wireFee"></mm-condensed-label-group>
  </div>
  <div class="column" *ngIf="isIrsAba && !!taxPayerId">
    <mm-condensed-label-group id="wireCondensed_taxPayerId" [title]="labels.taxPayerId" [data]="(taxPayerId | maskAccountNumber)"></mm-condensed-label-group>
  </div>
  <div class="column" *ngIf="isIrsAba && !!taxTypeCode">
    <mm-condensed-label-group id="wireCondensed_taxTypeCode" [title]="labels.taxTypeCode" [data]="taxTypeCode"></mm-condensed-label-group>
  </div>
  <div class="column" *ngIf="isIrsAba && !!taxYear">
    <mm-condensed-label-group id="wireCondensed_taxYear" [title]="labels.taxYear" [data]="taxYear"></mm-condensed-label-group>
  </div>
  <div class="column" *ngIf="isIrsAba && !!taxMonth">
    <mm-condensed-label-group id="wireCondensed_taxMonth" [title]="labels.taxMonth" [data]="taxMonth"></mm-condensed-label-group>
  </div>
  <div class="column" *ngIf="accountHolderRequestingTransaction">
    <mm-condensed-label-group id="wireCondensed_accountHolderRequestingTransaction" [title]="labels.accountHolderRequestingTransaction" [data]="accountHolderRequestingTransaction"></mm-condensed-label-group>
  </div>
  <div class="column" *ngIf="isConfirmationPage">
    <mm-condensed-label-group id="wireCondensed_federalReferenceNumber" data-testid="wireCondensed_federalReferenceNumber" [title]="labelRefNum" [data]="refNum"></mm-condensed-label-group>
  </div>
</div>
<div id="wireCondensed_wireDisclaimer">{{wireDisclaimer}}</div>
<div *ngIf="isConfirmationPage" id="wireCondensed_federalReferenceNumberDisclaimer">{{federalReferenceNumberDisclaimer}}</div>
